<template>
  <div class="main-about">
  <div class="about">
    <div class="about-text">
      <h2>درباره ما</h2>
      <p>لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح
        گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته
        شده استفاده می نماید.
      </p>
      <p>
        لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک
        از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
        استفاده می نماید.لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته
        می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح
        سفارش گرفته شده استفاده می نماید
      </p>
    </div>
    <the-about-home-section/>
    <div class="text-about">
      <p>
        لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده استفاده می نماید
      </p>
    </div>
    <the-user-info/>
    <div class="text">
      <p>
        لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده استفاده می نماید
      </p>
    </div>
  </div>
  </div>
</template>

<script>
import TheAboutHomeSection from "./Home/the-about-home-section";
import TheUserInfo from "./Home/the-user-info";

export default {
  name: "about",
  components: {TheUserInfo, TheAboutHomeSection}
}
</script>

<style lang="scss" scoped>
.main-about{
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("../assets/backgrounds/about.png");
  background-size:cover;
  background-position: center;
}
.about{
  display: flex;
  margin: 100px 0;
  flex-direction: column;
  gap: 50px;
  direction: rtl;
  color: #FBFBFD;
  font-size: clamp(14px , 2vw , 16px);
  width: 90%;
  justify-content: center;
  align-items: center;
  text-align: right;
}
</style>